import React, { useCallback } from "react";
import { Multiselect } from "./Multiselect";
import type { AttributesValues } from "interfaces/locals/locals.types";

type MultiselectFieldProps = {
  title: string;
  options: Record<string, string>[];
  attribute: AttributesValues;
  optionsSelected: Record<string, string>[];
  handleChange: (
    values: Record<string, string>[],
    attribute: AttributesValues,
  ) => void;
};

export const MultiselectField = React.memo(
  ({
    title,
    options,
    attribute,
    optionsSelected,
    handleChange,
  }: MultiselectFieldProps) => {
    const handleChangeWithAttribute = useCallback(
      (values: Record<string, string>[]) => {
        handleChange(values, attribute);
      },
      [attribute, handleChange],
    );

    return (
      <div key={`multiselect-${attribute}`} data-testid="multiselect-fields">
        <div className="scrivito_detail_label">
          <span>{title}</span>
        </div>
        <div data-testid={attribute}>
          <Multiselect
            options={options}
            optionsSelected={optionsSelected}
            handleChange={handleChangeWithAttribute}
          />
        </div>
      </div>
    );
  },
);
